"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Points = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../../../contexts");
var _hooks = require("../../../../hooks");
var _models = require("../../../../models");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component to render available points if offer is campaign offer.
 */
const Points = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    isCampaignOffer,
    offer: {
      availablePoints
    }
  } = (0, _contexts.useOfferDetail)();
  const {
    isHeartFormat
  } = (0, _contexts.useCheckoutOffers)();
  if (!isCampaignOffer) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-testid": getTestId(_models.TestId.AvailablePoints),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.PointsProgress, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AvailablePoints, {
        variant: "h3",
        children: availablePoints
      }), isHeartFormat ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.HeartsFilled, {}) : null]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PointsDescription, {
      variant: "overline",
      children: isHeartFormat ? translations.availableHearts : translations.availablePoints
    })]
  });
};
exports.Points = Points;